/** The OCaml compilers the runner ships; a room picks one ("OCaml compiler" in the status bar). */
export type OcamlCompiler = "ocaml" | "oxcaml";

export const OCAML_COMPILERS: Record<OcamlCompiler, { name: string; version: string }> = {
  ocaml: { name: "OCaml", version: "5.5.0" },
  oxcaml: { name: "OxCaml", version: "5.2.0minus31" },
};

export const DEFAULT_OCAML_COMPILER: OcamlCompiler = "ocaml";

export function isOcamlCompiler(value: unknown): value is OcamlCompiler {
  return value === "ocaml" || value === "oxcaml";
}
